// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2jXOZ","footer":"ModalFilter_footer__1uF24"};